(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[96890],{

/***/ 22871:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms",
      function () {
        return __webpack_require__(54327);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_terms; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
;// CONCATENATED MODULE: ./src/constants/contents/terms.tsx



var Terms = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        family: "bold",
                        as: "span",
                        children: "Stockbit"
                    }),
                    " ",
                    'provides the Stockbit.com website and any other websites or its affiliates (collectively, the "Site" or the "Sites") and the products and services available at the Sites (taken together with the Sites, the "Service") to you, the user, subject to your compliance with all the terms and conditions herein (the "Terms"), as well as any other written agreement between us and you. In these Terms, "you" or "your" means the person accepting these Terms and the company (if any) on whose behalf he/she is acting, and "we," "us," "our, "Stockbit," or the "Company" means Stockbit. and its affiliates.'
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    as: "span",
                    children: "BY USING THIS SITE, YOU AGREE TO BE BOUND BY THESE TERMS OF USE. PLEASE READ THESE TERMS CAREFULLY AS THEY CONTAIN IMPORTANT INFORMATION REGARDING YOUR LEGAL RIGHTS, REMEDIES AND OBLIGATIONS. THESE INCLUDE VARIOUS LIMITATIONS AND EXCLUSIONS, AND A DISPUTE RESOLUTION CLAUSE THAT GOVERNS HOW DISPUTES WILL BE RESOLVED."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "modifications-of-terms-of-use",
                children: "MODIFICATIONS OF TERMS OF USE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit reserves the right, at its sole discretion, to modify or replace the Terms of Use at any time. You shall be responsible for reviewing and becoming familiar with any such modifications. Use of the Services by you following such notification constitutes your acceptance of the terms and conditions of the Terms of Use as modified."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "registered-users-subcribers",
                children: "REGISTERED USERS & SUBCRIBERS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: 'In order to become a Registered User, you must create an account using the Website interface, and click on the activation link in the email that we will send to you. Registered Users gain access to additional services and restricted areas on the Website, which may include: (i) the ability to submit and edit posts to our Website streams and to like others\' posts; (ii) the facility to create a detailed profile which may be made available via the Website; (iii) access to our Website-based messaging system; (iv) in the case of Subscribers only, access to the Subscription Service including "Stockbit Data" which are financial data that we collect in-house and any intermediate algorithms and calculations that we undertake in respect of that data.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Registered Users must not allow any other person to use their user ID and password, and they must ensure that that user ID and password are kept confidential. Registered Users accept responsibility for all activities that occur under or in relation to their user ID and password. Upon our request, Registered Users and will provide to us proof of their identity and/or age."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We may also be required by law or regulation to identify Registered Users and disclose their details to a third party including the relevant legal or regulatory authority if requested by them to do so. We may alter or restrict the services and areas that Registered Users have access to, and/or delete any Registered User's account, in our sole discretion without notice or explanation."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You may only Use the Website if you are at least 18 years of age."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "copyright-and-limitations-on-use",
                children: "COPYRIGHT AND LIMITATIONS ON USE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: 'The content available through Stockbit.com is the property of Stockbit or its licensors and is protected by copyright and other intellectual property laws. Content includes for example, stories, tools, charts, calculators and other items displayed on the site. Content received through Stockbit.com may be displayed, reformatted, and printed for your personal, non-commercial use only. You agree not to reproduce, retransmit, distribute, disseminate, sell, publish, broadcast or circulate the content received through Stockbit.com to anyone, including but not limited to others in the same company or organization, nor any use of data mining, robots, spiders, or similar data gathering and extraction tools for any purpose without the express prior written consent of Stockbit, with this one exception: You may, on an occasional and irregular basis, disseminate an insubstantial portion of content from Stockbit.com, for a noncommercial purpose, without charge, and transmitted in non-electronic form, to a limited number of individuals, provided you include all copyright and other proprietary rights notices with such portion of the content in the same form in which the notices appear in Stockbit.com, original source attribution, and the phrase "Used with permission from Stockbit." You may not post any content from Stockbit.com to newsgroups, mail lists or electronic bulletin boards, without the prior written consent of Stockbit. Stockbit.com includes facts, views, opinions and recommendations of individuals and organizations deemed of interest. Stockbit and its content licensors do not guarantee the accuracy, completeness or timeliness of, or otherwise endorse, these views, opinions or recommendations, give tax or investment advice, or advocate the purchase or sale of any security or investment.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "The Subscriber further agrees that only one user will log in and use this subscription. Subscriptions are meant for one user only and are not to be shared. Additional users must have their own user id and password and their owner subscription."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "subscriber-fees",
                children: "SUBSCRIBER FEES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Subscriber will pay the Monthly Fee for the monthly subscription on a monthly basis and the Yearly Fee for a yearly subscription on a yearly basis. All fees will be paid at the beginning of service. The initial service period of the monthly subscription is one (1) month and will auto renew for subsequent one (1) month periods until 30 day notice is given by the Subscriber. The initial service period of the yearly subscription is one (1) year and will auto renew for subsequent one (1) year periods unless 30 day notice is given by the Subscriber. Service of the subscription will not begin until all charges have been processed."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit may offer, as indicated on the Order Form, a trial period for any of its subscription products. The Subscriber will be charged at the beginning of the initial service period for services, which starts after the trial period has concluded. Following any trial period, the normal terms of this Agreement will remain in effect."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Following the initial service period, Stockbit reserves the right to increase the Monthly or Yearly Fee at any time upon 30 days notice to Subscriber, provided Subscriber shall have the right to terminate the Subscription by providing Stockbit with written or email termination notice. Subscriber (a) agrees to pay the Monthly or Yearly Fee according to any applicable credit card issuer agreement, (b) expressly authorizes Stockbit to automatically charge the applicable card on a monthly or yearly basis during the term of this Agreement (unless otherwise agreed by the parties), and (c) agrees that any fee increase made in accordance with this Section may also be charged to the same card in the same manner."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "payment-method",
                children: "PAYMENT METHOD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit provides the following payment methods:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Credit Cards: Visa and Mastercard"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Internet Banking"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Virtual Account"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Veritrans"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Alfa Mart Retail Stores"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit is not responsible for any misuse of credit card or any payment methods that belongs to the user. The onus is on the credit card holders to input the details correctly when transacting and always safe-keep their credit card information only to themselves. Stockbit is not responsible for any transaction fraud arising from credit card payments or any other payment methods. Users will understand that any payment is assumed to be paid from the credit card holders/ bank account holders and will further understand that these fraud issues is beyond Stockbit control and hence will indemnify Stockbit from all liabilities arising from transactional fraud."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "All transactions will be processed in Rupiah and/or converted to the equivalent Rupiah value. All transaction will be processed within 24 hours."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "After completion of transaction, Stockbit would send Users a receipt of payment by email, listed on the Stockbit database within 1 day after payment process is completed."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "The electronic invoice sent is the proof of purchase and the Users reference for purchase."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Users are encouraged to keep the invoice of your purchases as evidence of transaction which may be useful in the future."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "When you successfully complete your order for our Subscription Service, you agree that the Product is immediately available to you. As the services are provided at your own request, we do not provide a refund after completion of purchase."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "subscriber-term-termination",
                children: "SUBSCRIBER TERM/TERMINATION"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Unless a specific initial term for this Agreement is specified in the Order Form, the initial term of the Agreement is one (1) month for the monthly subscription and one (1) Year for the yearly subscription. Following the initial term this Agreement shall auto-renew on a monthly basis or yearly basis until otherwise terminated. Upon 30 days written notice of termination to the other party, which termination shall be effective on the last day of the month in which the 30th or 365th day of the subscription occurs, either party may terminate this Agreement as to one, all, or any number of the Products referred to in the Order Form. Further, Stockbit reserves the right to immediately suspend performance or terminate this Agreement without notice and without liability in the event that: (a) Subscriber fails to pay any amount due to Stockbit or charges back through the applicable credit card company any amounts billed, (b) any Content that is necessary for Stockbit to perform its obligations is suspended or terminated and/ or (c) in the event of any conduct by Subscriber which Stockbit, in its sole discretion, considers to be unacceptable, or in the event of any breach by Subscriber of this Agreement. Stockbit may discontinue any of our subscription products at any time, with or without notice and for any reason, including if it believes that you are under 18. Any suspected fraudulent, abusive or illegal activity may be grounds for terminating your relationship and may be referred to appropriate law enforcement authorities."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Without prejudice to our other rights under these Terms, if you (including for the avoidance of doubt Registered Users and Subscribers) breach any of these Terms in any way, or if we reasonably suspect that you have breached any of these Terms in any way, we may:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(a) delete, move or edit any of your User Content;"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(b) send you one or more formal warnings;"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(c) temporarily suspend your access to the Website and/or the Subscription Service;"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(d) delete your account;"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(e) permanently prohibit you from using the Website and/or the Subscription Service;"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(f) block computers using your IP address from accessing the Website;"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(g) contact your internet services provider and request that they block your access to the Website; and/or"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(h) bring court proceeding against you for breach of contract or otherwise."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Where we suspend or prohibit or block your access to the Website, part of the Website, and/or the Subscription Service, your right to use the services available on this site immediately ceases. We shall not be liable to you or any third party for any claims or damages arising out of any termination or suspension or any other actions taken by us in connection with such termination or suspension. You must not take any action to circumvent such suspension or prohibition or block (including without limitation using a different account)."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "changed-terms",
                children: "CHANGED TERMS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit.com shall have the right at any time to change or modify the terms and conditions applicable to Subscriber's use of Stockbit.com, or any part thereof, or to impose new conditions, including (but not limited to) adding fees and charges for use. Such changes, modifications, additions or deletions shall be effective immediately upon notice thereof, which may be given by means including (but not limited to) posting on Stockbit.com, or by electronic or conventional mail, or by any other means by which Subscriber obtains notice thereof. Any use of Stockbit.com by Subscriber after such notice shall be deemed to constitute acceptance by Subscriber of such changes, modifications or additions."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "user-content",
                children: "USER CONTENT"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: 'You are solely responsible for the Content that you post on or through the Service, or otherwise transmit to or share with other Users (collectively, the "User Content"). You may not post or share User Content on the Service that you did not create or that you do not have permission to post. You acknowledge that Stockbit does not pre-screen or approve User Content, but that Stockbit shall have the right (but not the obligation) in its sole discretion to refuse, delete or remove any User Content that is available via the Service, in connection with violations of the letter or spirit of the Terms or for any other reason. You are solely responsible at your sole cost and expense for creating backup copies and replacing any User Content you post or store on the Service or otherwise provide to the Company.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: 'All postings, messages, text, images, video or other materials ("Content") posted or published on, uploaded to, transmitted through, or linked from, the Service (hereinafter, "post", "posted" or "published"), whether by users of the Service ("Users") or Creators (as defined below), are the sole responsibility of the person from whom such Content originated. Site and Content available through the Service may contain links to other websites which are completely independent of Stockbit. Stockbit makes no representation or warranty as to the accuracy, completeness or authenticity of the information contained in any such site. Your linking to any other websites is done at your own risk. You agree that you must evaluate, and bear all risks associated with, the use of any Content, that you may not rely on said Content, and that under no circumstances will Stockbit, its affiliates, or partners be liable in any way for any Content or for any loss or damage of any kind incurred as a result of the use of any Content posted or otherwise made available via the Service.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "When you post User Content to the Service, you authorize and direct us to make such copies thereof as we deem necessary in order to facilitate the posting and storage of the User Content on the Service. By posting User Content to any part of the Service, you automatically grant, and you represent and warrant that you have the right to grant, to the Company an irrevocable, perpetual, non-exclusive, transferable, fully paid, worldwide license (with the right to sublicense) to use, copy, publicly perform, publicly display, reformat, translate, excerpt (in whole or in part) and distribute such User Content for any purpose, commercial, advertising, or otherwise, on or in connection with the Service or the promotion thereof, to prepare derivative works of, or incorporate into other works, such User Content, and to grant and authorize sublicenses of the foregoing. Stockbit does not assert any ownership over your User Content; rather, as between us and you, subject to the rights granted to us in these Terms, you retain full ownership of all of your User Content and any intellectual property rights or other proprietary rights associated with your User Content."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You must ensure that your User Content, material linked to by the User Content, and the Use of User Content in accordance with these Terms:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(a) does not infringe any third party's rights (including without limitation Intellectual Property Rights, reputational rights, rights of confidence and rights of privacy);"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(b) does not give rise to any cause of action in any jurisdiction, whether against us, you or a third party;"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(c) does not violate any law, statute, ordinance, regulation, legally binding code or market conventions in any jurisdiction (including, without limit, financial services regulations) whether in the United Kingdom or elsewhere;"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(d) is not pornographic or sexually explicit;"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(e) does not duplicate or substantially duplicate User Content previously published on the Website;"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(f) is not threatening, abusive, harassing, menacing or contrary to the principles of internet etiquette;"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(g) does not constitute spam or marketing material (any omotional activity should only take place through your Profile, as discussed here [insert link]); and;"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(h) does not contain any viruses, Trojan horses, worms, time bombs or other computer programming routines that are intended to damage, detrimentally interfere with, surreptitiously intercept or expropriate any system, data or personal information."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You undertake to keep yourself informed as to the contents of our House Rules and to ensure that your User Content and your user behaviour is in line with the House Rules. We do not undertake to monitor your use of the Website or the posting of User Content by you or any third party on the Website. Nor do we warrant that the Users of the Website have adhered to these Terms, although we use reasonable endeavours to remove User Content which breaches these Terms after it has been brought to our attention. If you become aware of any User Content on the Website which breaches these Terms, you should notify us of that content immediately. You acknowledge that we may edit, delete and/or move User Content without notice or explanation."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "user-content-disclaimer",
                children: "USER CONTENT DISCLAIMER"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "The Service is not intended to provide tax, legal or investment advice, and nothing on the Service should be construed as an offer to sell, a solicitation of an offer to buy, or a recommendation for any security. Trading in such securities can result in immediate and substantial losses of the capital invested. You should only invest risk capital, and not capital required for other purposes. You alone are solely responsible for determining whether any investment, security or strategy, or any other product or service, is appropriate or suitable for you based on your investment objectives and personal and financial situation. You should also consult an attorney or tax professional regarding your specific legal or tax situation."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "The Content is to be used for informational and entertainment purposes only and the Service does not provide investment advice for any individual. Stockbit, its affiliates and partners specifically disclaim any and all liability or loss arising out of any action taken in reliance on Content, including but not limited to market value or other loss on the sale or purchase of any company, property, product, service, security, instrument, or any other matter."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "The creators of the Content may hold long or short positions in the companies are free to buy or sell those positions at will. The Creators may take positions inconsistent with the views expressed. User Content available on the Stockbit platform contain the Creators' own opinions, and none of the information contained therein constitutes a recommendation that any particular security, portfolio of securities, transaction, or investment strategy is suitable for any specific person. You further understand that the Creators will not advise you personally concerning the nature, potential, value or suitability of any particular security, portfolio of securities, transaction, investment strategy or other matter."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You understand that an investment in any security is subject to a number of risks, and that discussions of any security published on the Service will not contain a list or description of relevant risk factors. In addition, please note that some of the stocks about which Content is published on the Service have a low market capitalization and/or insufficient public float. Such stocks are subject to more risk than stocks of larger companies, including greater volatility, lower liquidity and less publicly available information."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "warranties",
                children: "WARRANTIES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You acknowledge that the Website and the material on the Website may be changed from time to time without notice."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Notwithstanding the warranties above, Stockbit is not authorised to give investment advice and nothing on the Website should be interpreted as Stockbit seeking to offer such advice. Stockbit Content, Stockbit Data, User Content and/or relevant Third Party Content is provided 'as is' and may contain errors or inaccuracies. You should seek confirmation from an authoritative third party source of any information found on the Website upon which you may wish to rely. Use of Stockbit Content, Stockbit Data, User Content and/or Third Party Content is solely at the Subscriber's risk."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Subscriber acknowledges that the use and interpretation of the Stockbit Data, and any data analysis tools provided as part of the Subscription Service requires skill and judgement. Subscribers shall at all times exercise their own skill and judgement in the Use and interpretation of the Subscription Service and shall be solely responsible for the purposes for which it is used and for all opinions, recommendations, forecasts and other comments made or action taken by Subscribers based wholly or partly on the Stockbit Data and/or data analysis tools."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit's Subscription Service includes access to pre-defined investor screens based on the work of famous investors, such as Benjamin Graham. We do not choose the companies on these lists. All the screens are based on set quantitative criteria, which are taken either from research papers or from the writings of investing gurus. However, please note that the screening criteria used may represent Stockbit's interpretation of the author's investment approach based on the available data-set and will not be determined or endorsed by the original strategist. You should consider the results of any screen as candidates for further research, not as a buy list or as a set of recommendations."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "These investor screens are intended purely as an educational tool to test the performance of different investment approaches in the Indonesian market. Our performance tracking ignores the impact of factors such as spreads, commissions, spreads and dividends. While this means that the reported performance is likely to be unachievable, this allows a useful comparison of different investment styles under different market conditions."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Subject to the warranty given above in respect of the paid-for Subscription Service:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(a) we do not warrant the completeness, veracity, bona fides or accuracy of the material on the Website; nor do we commit to ensuring that the Website remains available or that the material on the Website is kept up-to-date;"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(b) we do not grant to you any warranties or make any representations relating to the Website or your Use of the Website, and to the fullest extent permitted by applicable law we exclude all warranties and representations."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You acknowledge that the material on the Website submitted by third parties (including our Registered Users) from time to time is the sole responsible of the third party who has submitted that material. If you become aware of any inaccuracy or error on the website, please let us know."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "indemnity",
                children: "INDEMNITY"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You agree to indemnify and hold the Company, its subsidiaries and affiliates, and each of their members, managers, directors, officers, agents, contractors, partners and employees, harmless from and against any loss, liability, claim, demand, damages, costs and expenses, including reasonable attorney's fees, arising out of or in connection with your use of the Service, Subscriber's Account, any Content you post or Content you share on or through the Service or otherwise, your conduct in connection with the Service or with other Users, or any violation of these Terms or of any law, rule, regulation or order, or the rights of any third party. This indemnity shall survive any termination or cessation of use by you of the Service."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "financial-disclaimer",
                children: "FINANCIAL DISCLAIMER"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit.com is a financial data and news portal, discussion forum and content aggregator. Stockbit is not a broker/dealer, we are not an investment advisor, we have no access to non-public information about publicly traded companies, and this is not a place for the giving or receiving of financial advice, advice concerning investment decisions or tax or legal advice. We are not regulated by the Financial Services Authority."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit is an educational forum for analysing, learning & discussing general and generic information related to stocks, investments and strategies. No content on the site constitutes - or should be understood as constituting - a recommendation to enter in any securities transactions or to engage in any of the investment strategies presented in our site content. We do not provide personalised recommendations or views as to whether a stock or investment approach is suited to the financial needs of a specific individual."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Much of the content on this site is user-generated and, as such, impossible to monitor effectively. Excluding the Stockbit Data, all of the information on our Website about businesses, companies, investment strategies, investments and investment opportunities is provided by our Registered Users and other third parties. We act as a mere conduit for this information published on our Website, and we do not select, monitor, edit, modify review, evaluate or otherwise oversee the information or the publication of the information on our Website."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Where we present investment screens, the results should only be treated as candidates for further research, not as a buy list or set of recommendations. Screening may help to narrow a search based on pre-defined criteria but it is not a substitute for independent research reflecting your individual criteria for investing/trading."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit Data is intended to be used and must be used for informational purposes only. Stockbit Data is provided 'as is' and may contain errors or inaccuracies. It is very important to do your own analysis before making any investment based on your own personal circumstances. You should take professional financial advice in connection with, or independently research and verify, any information that you find on our Website and wish to rely upon, whether for the purpose of making an investment decision or otherwise. Any arrangements between you and any third party contacted via the Website are at your sole risk."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Accordingly, we will not be liable, whether in contract, tort (including negligence) or otherwise, in respect of any damage, expense or other loss you may suffer arising out of such information or any reliance you may place upon such information."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit and PT Bursa Efek Indonesia (Indonesia Stock Exchange) do not warrant and guarantee the accuracy of the information and hereby disclaim all liabilities and losses arising out of the use and reliance of this information."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Our Website is directed only to Indonesian residents. For the avoidance of doubt, the Website is not being offered in the US or Canada or to US persons or Canadian persons. Nothing on this Website or any part thereof is intended to constitute an offer or solicitation to buy or sell investments in any jurisdiction."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "general-disclaimer",
                children: "GENERAL DISCLAIMER"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "The Service may be temporarily unavailable from time to time for maintenance or other reasons. The Company assumes no responsibility for any error, omission, interruption, deletion, defect, delay in operation or transmission, communications line failure, theft or destruction or unauthorized access to, or alteration of, User Content. The Company is not responsible for any technical malfunction or other problems of any telephone network or service, computer systems, servers or providers, computer or mobile phone equipment, or software on account of technical problems or traffic congestion on the Internet or at any site or with respect to the Service or combination thereof, including injury or damage to User's or to any other person's computer, mobile phone, or other hardware or software, related to or resulting from using or downloading Content in connection with the Web and/or in connection with the Service. Under no circumstances will the Company be responsible for any loss or damage, including any loss or damage to any User Content or personal injury or death, resulting from anyone's use of the Service or any posted on or through the Service or transmitted to or by Users, or any interactions between Users, whether online or offline."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: 'All market data is a real-time snapshot, delayed at least 10 minutes. All market data and analysis information provided "as is" for informational purposes only, not intended for trading purposes or advice. Stockbit is not liable for any informational errors, incompleteness, or delays, or for any actions taken in reliance on information contained herein.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: 'Stockbit is not a registered broker-dealer and does not endorse or recommend the services of any brokerage company. The brokerage company you select (and not Stockbit) is solely responsible for its services to you. STOCKBIT, ITS AFFILIATES, AND PARTNERS SHALL NOT BE LIABLE FOR ANY DAMAGES OR COSTS OF ANY TYPE ARISING OUT OF OR IN ANY WAY CONNECTED WITH YOUR USE OF THE SERVICES OF ANY BROKERAGE COMPANY. THE SERVICE AND THE CONTENT ARE PROVIDED "AS-IS" AND THE COMPANY, ITS PARTNERS AND AFFILIATES, DISCLAIM ANY AND ALL REPRESENTATIONS AND WARRANTIES, WHETHER EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR NON-INFRINGEMENT. THE COMPANY CANNOT GUARANTEE AND DOES NOT PROMISE ANY SPECIFIC RESULTS FROM USE OF THE SERVICE. THE COMPANY DOES NOT REPRESENT OR WARRANT THAT SOFTWARE, CONTENT OR MATERIALS ON THE SERVICE OR ELSEWHERE ARE ACCURATE, COMPLETE, RELIABLE, CURRENT OR ERROR-FREE OR THAT THE SERVICE OR ANY OF THE SERVERS USED TO OPERATE THE SERVICE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. THEREFORE, YOU SHOULD EXERCISE CAUTION IN THE USE AND DOWNLOADING OF ANY CONTENT OR MATERIALS AND USE INDUSTRY-RECOGNIZED SOFTWARE TO DETECT AND DISINFECT VIRUSES. WITHOUT LIMITING THE FOREGOING, YOU UNDERSTAND AND AGREE THAT YOU DOWNLOAD OR OTHERWISE OBTAIN CONTENT, DATA OR OTHER MATERIAL FROM OR THROUGH THE SERVICE AT YOUR OWN DISCRETION AND RISK AND THAT YOU WILL BE SOLELY RESPONSIBLE FOR YOUR USE THEREOF AND ANY DAMAGES TO YOUR MOBILE DEVICE OR COMPUTER SYSTEM, LOSS OF DATA OR OTHER HARM OF ANY KIND THAT MAY RESULT.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You agreed to the publication of feedback and comments about you by others on the Website, you acknowledge that such feedback and comments may be critical or defamatory, and you agree that you will not hold us liable in respect of any such feedback and comments, irrespective of whether we are aware or ought to have been aware of such feedback and comments. Nothing in these Terms will exclude or limit our liability for fraud, for death or personal injury caused by our negligence, or for any other liability which cannot be excluded or limited under applicable law."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit reserves the right to change any and all Content, software and other items used or contained in the Service at any time without notice. Reference to any products, services, processes or other information, by trade name, trademark, manufacturer, supplier or otherwise does not constitute or imply endorsement, sponsorship or recommendation thereof, or any affiliation therewith, by the Company."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "third-party-content",
                children: "THIRD PARTY CONTENT"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit.com is a distributor (and not a publisher) of content supplied by third parties and Subscribers. Any opinions, advice, statements, services, offers, or other information or content expressed or made available by third parties, including information providers, Subscribers or any other user of Stockbit.com, are those of the respective author(s) or distributor(s) and not of Stockbit.com. Neither Stockbit.com nor any third-party provider of information guarantees the accuracy, completeness, or usefulness of any content, nor its merchantability or fitness for any particular purpose. In many instances, the content available through Stockbit.com represents the opinions and judgments of the respective information provider, Subscriber, or other user not under contract with Stockbit.com. Stockbit.com neither endorses nor is responsible for the accuracy or reliability of any opinion, advice or statement made on Stockbit.com by anyone other than authorized Stockbit.com employee spokespersons while acting in their official capacities. Under no circumstances will Stockbit.com be liable for any loss or damage caused by a Subscriber's reliance on information obtained through Stockbit.com. It is the responsibility of Subscriber to evaluate the accuracy, completeness or usefulness of any information, opinion, advice or other content available through Stockbit.com. Please seek the advice of professionals, as appropriate, regarding the evaluation of any specific information, opinion, advice or other content."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Users may find advertising or other content on our Site that link to the sites and services of our partners, suppliers, advertisers, sponsors, licensors and other third parties. We do not control the content or links that appear on these sites and are not responsible for the practices employed by websites linked to or from our Site. In addition, these sites or services, including their content and links, may be constantly changing. These sites and services may have their own privacy policies and customer service policies. Browsing and interaction on any other website, including websites which have a link to our Site, is subject to that website's own terms and policies. You agree to indemnify Stockbit for any losses, costs, expenses or damages incurred by Stockbit due to your violation of a third party's Terms of Service. You should review the applicable terms and policies, including privacy and data gathering practices, of any third party services which you utilize or to any links to which you navigate."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "trademarks",
                children: "TRADEMARKS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit brand and other Stockbit graphics, logos, designs, page headers, button icons, scripts, categories, forum and service name are registered trademarks, trademarks or trade dress of Stockbit in the Republic of Indonesia and/or other countries. Stockbit's trademarks and trade dress may not be used, including as part of trademarks and/or as part of domain names, in connection with any product or service in any manner that is likely to cause confusion. Any intention to use the Stockbit logo and other trademarks must be requested and agreed upon in written by Stockbit."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "house-rules",
                children: "HOUSE RULES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Stockbit has a set of House Rules that further govern the conduct of all Users. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/rules",
                        children: "Click here"
                    }),
                    " to view the Stockbit House Rules. Please read the House Rules carefully before using the Service. The House Rules are incorporated herein by reference."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "subscription-trial-period",
                children: "SUBSCRIPTION TRIAL PERIOD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "The duration of any Trial Period shall be as specified on the Website. Use of the Subscription Service shall be free of charge during the Trial Period. Unless you provide Stockbit with notice to terminate the Subscription Service prior to the end of the Trial Period (by unsubscribing on the Website), the Charges provisions shall apply and govern your ongoing Use of the Subscription Service."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "After the Trial Period expires you shall be liable to pay the Charges. You accept that by providing your Veritrans account or your credit or debit card details you authorise Stockbit to deduct the Charges (or instalments of the Charges) using such payment method (as applicable) on a regular basis and in advance until the you terminate or cancel your subscription to the Subscription Service. The amount of the Charges shall be as displayed from time to time on the Website and may change from time to time."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You may only have one Trial Period. Should we identify that you have already made use of a Free Trial Period with the Subscription Service, you will immediately be billed for the Charges."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "charges",
                children: "CHARGES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Subject to the Trial Period provisions above, in consideration for the provision of the Subscription Service, Subscribers agree to pay the Charges as detailed on the Website from time to time. Without prejudice to its rights to recover the sums outstanding from the Subscriber,should Stockbit not be able to withdraw any part of the Charges from the Subscriber's Veritrans account or credit or debit card, Stockbit reserves the right to:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "suspend access to the Subscription Service; or"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "terminate this agreement to access the Subscription Service"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "refund",
                children: "REFUND"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit generally do not provide refunds or cancellation on its product after payment has been paid unless a mistake is made/ proven to be made by Stockbit."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Any Billing Assistance will be conducted by email",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        family: "bold",
                        as: "span",
                        children: "(support@Stockbit.com)"
                    }),
                    ". Our customer service centre will be open business days and hours Monday to Friday and closed on weekends."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "privacy",
                children: "PRIVACY"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "We care about the privacy of our Users.",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/privacy",
                        children: "Click here"
                    }),
                    " to view the Stockbit Privacy Policy. By using the Service, you are consenting to have your personal data transferred to and processed in the Republic of Indonesia. As part of providing you the Service, we may need to provide you with certain communications, such as service announcements and administrative messages. These communications are considered part of the Services and your Stockbit account, which you may not be able to opt-out from receiving."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "governing-law",
                children: "GOVERNING LAW"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "This site (excluding any linked sites) is controlled by us from our offices within the DKI Jakarta, Indonesia. It can be accessed from Indonesia, as well as from other countries around the world. As each of these places has laws that may differ from those of Republic of Indonesia, by accessing this site both of us agree that the statutes and laws of the Republic of Indonesia. Each of us agrees and hereby submits to the exclusive personal jurisdiction and venue any court of competent jurisdiction within the Republic of Indonesia with respect to such matters."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "submissions",
                children: "SUBMISSIONS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: 'You acknowledge and agree that any questions, comments, suggestions, ideas, feedback or other information about the Service ("Submissions"), provided by you to the Company are non-confidential and shall become the sole property of the Company. The Company shall own exclusive rights, including all intellectual property rights, and shall be entitled to the unrestricted use and dissemination of these Submissions for any purpose, commercial or otherwise, without acknowledgment or compensation to you.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "general",
                children: "GENERAL"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "These Terms constitute the entire agreement between you and the Company regarding the use of the Service, superseding any prior agreements between you and the Company relating to your use of the Service. The failure of the Company to exercise or enforce any right or provision of these Terms shall not constitute a waiver of such right or provision in that or any other instance. If any provision of these Terms is held invalid, the remainder of these Terms shall continue in full force and effect. If any provision of these Terms shall be deemed unlawful, void or for any reason unenforceable, then that provision shall be deemed severable from these Terms and shall not affect the validity and enforceability of any remaining provisions."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "If you have any questions about this Terms of Use, the practices of this site, or your dealings with this site, please contact us at:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "RDTX Square 33rd Floor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "Jl. Prof. Dr. Satrio No 164 - Jakarta 12930"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "Phone : +62 21 50959330"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "Whatsapp business : +62 21 50864219"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "Email : Support@stockbit.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "Operational hours: 09:00 - 16.30"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var terms = (Terms);

;// CONCATENATED MODULE: ./pages/terms.tsx

__webpack_require__(14473);


var UserArticleLayout = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(74885), __webpack_require__.e(25287), __webpack_require__.e(94119), __webpack_require__.e(78656), __webpack_require__.e(71577), __webpack_require__.e(75819), __webpack_require__.e(46819), __webpack_require__.e(42871), __webpack_require__.e(12603), __webpack_require__.e(7648), __webpack_require__.e(25935), __webpack_require__.e(97751), __webpack_require__.e(80129), __webpack_require__.e(51225), __webpack_require__.e(36661), __webpack_require__.e(27251), __webpack_require__.e(53954), __webpack_require__.e(29117), __webpack_require__.e(50626), __webpack_require__.e(1011), __webpack_require__.e(33070), __webpack_require__.e(67555), __webpack_require__.e(78497), __webpack_require__.e(265), __webpack_require__.e(91036), __webpack_require__.e(54253), __webpack_require__.e(48761), __webpack_require__.e(47407), __webpack_require__.e(88042), __webpack_require__.e(6916), __webpack_require__.e(64435), __webpack_require__.e(48308), __webpack_require__.e(81617), __webpack_require__.e(71151), __webpack_require__.e(74768), __webpack_require__.e(40927), __webpack_require__.e(77284), __webpack_require__.e(74317), __webpack_require__.e(6870), __webpack_require__.e(43156)]).then(__webpack_require__.bind(__webpack_require__, 12661));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12661)
            ];
        }
    }
});
var ArticleLayout = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25287), __webpack_require__.e(94119), __webpack_require__.e(71577), __webpack_require__.e(75819), __webpack_require__.e(42871), __webpack_require__.e(12603), __webpack_require__.e(97751), __webpack_require__.e(10534), __webpack_require__.e(73942)]).then(__webpack_require__.bind(__webpack_require__, 10534));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10534)
            ];
        }
    }
});
var TermsPage = function(param) {
    var isLoggedIn = param.isLoggedIn;
    if (isLoggedIn) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserArticleLayout, {
            source: /*#__PURE__*/ (0,jsx_runtime.jsx)(terms, {}),
            title: "Terms"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleLayout, {
        source: /*#__PURE__*/ (0,jsx_runtime.jsx)(terms, {}),
        title: "Terms"
    });
};
var __N_SSP = true;
/* harmony default export */ var pages_terms = (TermsPage);


/***/ }),

/***/ 22147:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Color name source http://www.htmlcsscolor.com/
 */ /* harmony default export */ __webpack_exports__["Z"] = ({
    light: "#FFFFFF",
    highempahis: "#333333",
    highgray: "#969696",
    midgray: "#B5B5B5",
    lowgray: "#CBCBCB",
    downgray: "#EDEDED",
    component: "#F5F5F5",
    primary: "#00ab6b",
    "primary60%": "#00ab6b99",
    secondary: "#3b5998",
    trading: "#2facb2",
    gainsboro: "#DADADA",
    whisper: "#EEEEEE",
    silver: "#BBBBBB",
    aliceBlue: "#F5F6F7",
    snow: "#F9F9F9",
    dimgray: "#6b6b6b",
    black: "#000000",
    nightRider: "#333333",
    zambezi: "#595959",
    veryLightGrey: "#CCCCCC",
    suvaGrey: "#939393",
    highball: "#979134",
    sunsetOrange: "#ee4a49",
    clearDay: "#e6f8f1",
    darkGray: "#AAAAAA",
    dimGray: "#666666",
    mintCream: "#eafff7",
    nobel: "#999999",
    bubbles: "#DEF2E5",
    heather: "#B5B6B7",
    bermuda: "#80D5B5",
    sundown: "#F7A5A4",
    hummingBird: "#cceee1",
    coralCandy: "#FAC8C8",
    darkGrey: "#AAAAAA",
    valencia: "#d9534f",
    mischka: "#a2a7b0",
    royalBlue: "#5766D3",
    steelBlue: "#4178bb",
    scooter: "#2c8aa3",
    java: "#169b8b",
    jade: "#00ad73",
    /* handling hex code with duplicate name */ "seasonality-darkest-green": "#006c00",
    "seasonality-medium-green": "#018601",
    "seasonality-green": "#009b00",
    "seasonality-bright-green": "#01ad01",
    "seasonality-darkest-red": "#a70000",
    "seasonality-medium-red": "#c20d0d",
    "seasonality-red": "#d00808",
    "seasonality-bright-red": "#e70000",
    amber: "#ffbf00",
    mintTulip: "#bde9d9",
    dodgerBlue: "#1E90FF",
    navyBlue: "#136ad5",
    whiteSmoke: "#F2F2F2",
    pigmentGreen: "#019934",
    lightGreen: "#90E897",
    monaLisa: "#ff988e",
    purpleHeart: "#7924c3",
    venetianRed: "#c11214",
    green: "#0c8414",
    cadetBlue: "#49a3ac",
    pinkSwan: "#B6B6B6",
    grannyApple: "#C7F3CB",
    alertRed: "#FCD0CE",
    alertOrange: "#F0AD4E",
    alertBlue: "#337AB7",
    yellowSea: "#eba031",
    chardonnay: "#ffc774",
    softgreen: "#E5F7F0",
    mountainMeadow: "#0bba7a",
    grey: "#777777",
    nero: "#222222",
    ghostWhite: "#f8f8f9",
    azureBlue: "#2F8EF7",
    bitterSweet: "#fc605c",
    supernova: "#fdbc40",
    limeGreen: "#34c84a",
    softGainsboro: "#DDDDDD",
    mediumAquamarine: "#5dcbad",
    cosmicLatte: "#e1f6e5",
    vividViolet: "#712E9E"
});


/***/ }),

/***/ 95541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n  padding: ",
        ";\n  width: ",
        ";\n  text-transform: ",
        ";\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  & > a {\n    color: ",
        ";\n    text-decoration: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var familyType = {
    regular: "ProximaNovaRg",
    light: "ProximaNovaLt",
    bold: "ProximaNovaBd"
};
/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "ellipsis",
            "textTransform"
        ].includes(prop);
    }
}).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: props.size || "14px",
        weight: props.weight || "normal",
        height: props.height || "normal",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis,
        align: props.align || "left",
        padding: props.padding || 0,
        width: props.width,
        ellipsis: props.ellipsis,
        textTransform: props.textTransform,
        family: props.family || "regular"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8a078c1d-0"
})(_templateObject3(), function(param) {
    var family = param.family;
    return familyType[family];
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(param) {
    var height = param.height;
    return height;
}, function(props) {
    return props.color;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var textTransform = param.textTransform;
    return textTransform;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, function(param) {
    var ellipsis = param.ellipsis;
    return ellipsis && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}));


/***/ }),

/***/ 52435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ spacingProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);




var types = {
    m: "margin",
    p: "padding"
};
var directions = {
    t: [
        "-top"
    ],
    r: [
        "-right"
    ],
    b: [
        "-bottom"
    ],
    l: [
        "-left"
    ],
    x: [
        "-left",
        "-right"
    ],
    y: [
        "-top",
        "-bottom"
    ]
};
var EMPTY_STRING = "";
var WHITE_SPACE = " ";
var REGEX = /^([mp][trblxy]?)$/;
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(prev, f) {
            return f(prev, x);
        }, x);
    };
};
var filter = function(keys) {
    return keys.filter(function(key) {
        return key.match(REGEX);
    });
};
var merge = function(props) {
    return props.map(function(param) {
        var type = param.type, direction = param.direction, value = param.value;
        return direction.map(function(d) {
            return "".concat(type).concat(d, ": ").concat(value, ";");
        }).join(WHITE_SPACE);
    });
};
var splitPropKey = function(keys, props) {
    return keys.map(function(key) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key.split(""), 2), type = ref[0], direction = ref[1];
        return {
            type: types[type],
            direction: directions[direction] || [
                EMPTY_STRING
            ],
            value: props[key]
        };
    });
};
var handleSpaces = function(props) {
    return pipe(Object.keys, filter, splitPropKey, merge)(props).join(WHITE_SPACE);
};
var spacingProps = function(props) {
    var typesKeys = Object.keys(types);
    var directionsKeys = Object.keys(directions);
    var result = typesKeys.map(function(type) {
        return directionsKeys.map(function(dir) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, "".concat(type).concat(dir), props["".concat(type).concat(dir)]);
        });
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(curr));
    }, []).filter(function(prop) {
        return Object.values(prop)[0];
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prev, curr);
    }, {});
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, result);
};
/* harmony default export */ __webpack_exports__["Z"] = (handleSpaces);


/***/ }),

/***/ 20:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/backpack/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["backpack"]) {
      return resolve(window.remoteLoading["backpack"])
    }

    var res, rej;
    window.remoteLoading["backpack"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["backpack"] !== 'undefined') {
      res(window["backpack"]);
      return resolve(window["backpack"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
          res(window["backpack"]);
          return resolve(window["backpack"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "backpack"
    );
  }).then(function () {
    const proxy = {
      get: backpack.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          backpack.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        backpack.__initialized = true
      }
    }
    if (!backpack.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 86643:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.7.11/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 63329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/3.0.3/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 6019:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.4/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 36305:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [63332,49774,92888,40179], function() { return __webpack_exec__(22871); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);